import { FiArrowLeft, FiCheck, FiRotateCcw } from 'react-icons/fi';

export default function OpeningBalanceHeader({
  navigate,
  title,
  yearLabel,
  status,
  frozen,
  locked,
  balanceDifference,
  readOnlyReport,
  onLock,
  onUnlock,
}) {
  const hasDiff = Math.abs(balanceDifference || 0) > 0.009;
  return (
    <div className="page-header">
      <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
        <button className="btn btn-ghost btn-sm" onClick={() => navigate('/accounting/financial-years')}>
          <FiArrowLeft />
        </button>
        <h2>{title} - {yearLabel}</h2>
        <span className={`badge ${status === 'frozen' ? 'badge-admin' : status === 'locked' ? 'badge-approved' : 'badge-pending'}`}>
          {status}
        </span>
        {locked && hasDiff && (
          <span className="badge badge-rejected" title={`Balance difference: ₹${Math.abs(balanceDifference).toFixed(2)}`}>
            diff ₹{Math.abs(balanceDifference).toFixed(2)}
          </span>
        )}
      </div>

      <div style={{ display: 'flex', gap: 8 }}>
        {!readOnlyReport && !frozen && locked && (
          <button className="btn btn-ghost btn-sm" onClick={onUnlock}>
            <FiRotateCcw /> Unlock OB
          </button>
        )}
        {!readOnlyReport && !frozen && !locked && (
          <button className="btn btn-success btn-sm" onClick={onLock}>
            <FiCheck /> Lock OB
          </button>
        )}
      </div>
    </div>
  );
}
